export const ownGoodsItemStyle = ({ palette }) => ({
  ownCard: {
    margin: '20px 0 0 0',
  },
  header: {
    borderBottom: '1px solid ' + palette.divider,
    padding: '0.9375rem 20px',
  },
  timeIcon: {
    fontSize: '16px',
    color: palette.text.secondary,
    margin: '0 5px -3px 0',
  },
  title: {
    fontSize: '24px',
    lineHeight: '28px',
    color: palette.text.primary,
  },
  marginTop: {
    marginTop: '10px',
  },
  fullWidth: {
    width: '100%',
  },
  fullHeight: {
    height: '100%',
  },
})
